import type { Column } from "@tanstack/react-table";
import { InfoIcon } from "lucide-react";

import { Popover } from "src/components/Popover";

import type { DataTableColumnMeta } from "../types";

interface HeaderDescriptionProps<TData> {
  column: Column<TData, unknown>;
}

export const HeaderDescription = <TData,>({
  column,
}: HeaderDescriptionProps<TData>) => {
  const meta = column.columnDef.meta as DataTableColumnMeta | undefined;
  const description = meta?.description;

  if (!description) return null;

  return (
    <Popover
      position="bottom"
      trigger={
        <span
          className="ml-1 inline-flex"
          onClick={e => e.stopPropagation()}
          data-testid={`column-description-${column.id}`}
        >
          <InfoIcon
            aria-hidden="true"
            className="size-4 text-muted-foreground"
          />
        </span>
      }
    >
      {description}
    </Popover>
  );
};
